module.exports = __webpack_public_path__ + "static/media/contact-illustration.2933df95.svg";